import { FC, useEffect } from 'react';
import DashboardInventory from '../components/DashboardInventory';
import { useSnapshot } from 'valtio';
import { useSearchParams } from 'react-router-dom';
import TopBarStore from '../../app/stores/top-bar-store';
import InventoryFiltersStore from '../stores/inventory-filters-store';
import { loadInventory } from '../actions/inventory-actions';
import { updateFilters } from '../stores/inventory-filters-store-actions';
import { useAppOwners } from '../../application-owners/api/applications-owners-api';
import { useGradualUpdate } from '../../new-scan/actions/scan-actions';
import { InventoryFilterType } from '../inventory-types';

const DashboardInventoryContainer: FC<
  React.PropsWithChildren<DashboardInventoryContainerProps>
> = ({ hideAppsCount }) => {
  const { dateRange } = useSnapshot(TopBarStore);
  const { displaySelectedAppOwners } = useAppOwners();
  useEffect(() => {
    loadInventory();
  }, [dateRange, displaySelectedAppOwners]);

  useGradualUpdate(loadInventory);

  const [searchParams, setSearchParams] = useSearchParams();

  const {
    inventoryAppsNumber,
    inventoryAppsNotRelevant,
    inventoryFilters,
    filters: appliedFilters,
  } = useSnapshot(InventoryFiltersStore);

  const onInventoryFilterClick = (filter: InventoryFilterType) => {
    const updatedFilters = updateFilters(filter);
    searchParams.set('filter', encodeURI(JSON.stringify(updatedFilters)));
    setSearchParams(searchParams);
    loadInventory();
  };

  return (
    <DashboardInventory
      appliedFilters={appliedFilters}
      unRelevantApps={inventoryAppsNotRelevant}
      apps={inventoryAppsNumber}
      filters={inventoryFilters}
      onInventoryFilterClick={onInventoryFilterClick}
      hideAppsCount={hideAppsCount}
    />
  );
};

interface DashboardInventoryContainerProps {
  hideAppsCount?: boolean;
}

export default DashboardInventoryContainer;
